
export default [
    {
        key: 'producer',
        label: 'Produzent:in',
        icon: 'fa fa-industry',
    },
    {
        key: 'wholesale',
        label: 'Großhandel',
        icon: 'fa fa-warehouse',
    },
    {
        key: 'retail',
        label: 'Einzelhandel',
        icon: 'fa fa-store',
        color: 'blue'
    },
    {
        key: 'bakery',
        label: 'Bäckerei',
        icon: 'fa fa-bread-slice',
        color: 'brown'
        // TODO: icon & color
    },
    {
        key: 'farmer',
        label: 'Bäuer:in',
        icon: 'fa fa-leaf',
        color: 'green'
    },
    {
        key: 'other',
        label: 'Sonstiges / NonFood',
        icon: 'far fa-circle'
    }
]
